module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-two2.7985ec03.png";